import { gql } from 'graphql-tag';

export const GET_WAREHOUSES = gql`
  query GetWarehouses($pagination: PaginationInput, $sort: WarehouseSortInput) {
    warehouses(pagination: $pagination, sort: $sort) {
      data {
        id
        name
        street
        zip
        city
        country
        isDefault
        accountId
        partsCount
        createdAt
        updatedAt
      }
      meta {
        page
        limit
        total
        totalPages
        hasNext
        hasPrev
      }
    }
  }
`;

export const GET_WAREHOUSE = gql`
  query GetWarehouse($id: ID!) {
    warehouse(id: $id) {
      id
      name
      street
      zip
      city
      country
      isDefault
      accountId
      partsCount
      createdAt
      updatedAt
    }
  }
`;
